import { useState } from 'react';
import { poSubtotal, poTotalJmd } from '../../lib/purchaseOrders';
import { formatJMD, formatUSD } from '../../lib/finances';
import Badge from '../Badge';
import { todayISO } from '../../lib/dates';

const STATUS_TONE = { Ordered: 'neutral', Shipped: 'warning', Received: 'success', Cancelled: 'muted' };


export default function PurchaseOrderCard({ po, onEdit, onDelete, onSetStatus }) {
  const [expanded, setExpanded] = useState(false);

  const items = po.purchase_order_items || [];
  const subtotal = poSubtotal(items);
  const totalJmd = poTotalJmd(items, po.exchange_rate);

  return (
    <div className="po-card">
      <div className="po-card-header" onClick={() => setExpanded((v) => !v)}>
        <div>
          <div className="po-card-title">
            {po.po_number}
            <Badge tone={STATUS_TONE[po.status]}>{po.status}</Badge>
          </div>
          <div className="po-card-vendor">{po.vendor?.name || 'Unknown vendor'}</div>
        </div>
        <div className="po-card-stats">
          <span>Ordered {po.order_date}</span>
          {po.expected_delivery_date && <span>Expected {po.expected_delivery_date}</span>}
          {po.actual_delivery_date && <span>Received {po.actual_delivery_date}</span>}
          <span>{formatJMD(totalJmd)}</span>
        </div>
      </div>

      {expanded && (
        <div className="po-card-body">
          {po.notes && <p className="po-card-notes">{po.notes}</p>}

          <table className="po-item-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Qty</th>
                <th>Unit cost</th>
                <th>Line total</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>{item.item_name}</td>
                  <td>{item.quantity}</td>
                  <td>
                    {po.currency === 'USD'
                      ? formatUSD(item.unit_cost)
                      : formatJMD(item.unit_cost)}
                  </td>
                  <td>
                    {po.currency === 'USD'
                      ? formatUSD(item.quantity * item.unit_cost)
                      : formatJMD(item.quantity * item.unit_cost)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}>Subtotal ({po.currency})</td>
                <td>{po.currency === 'USD' ? formatUSD(subtotal) : formatJMD(subtotal)}</td>
              </tr>
              {po.currency === 'USD' && (
                <tr>
                  <td colSpan={3}>JMD equivalent</td>
                  <td>{formatJMD(totalJmd)}</td>
                </tr>
              )}
            </tfoot>
          </table>

          <div className="po-card-actions">
            {po.status === 'Ordered' && (
              <>
                <button onClick={() => onSetStatus(po.id, 'Shipped')}>Mark as shipped</button>
                <button onClick={() => onSetStatus(po.id, 'Cancelled')}>Cancel order</button>
              </>
            )}
            {po.status === 'Shipped' && (
              <>
                <button
                  onClick={() => onSetStatus(po.id, 'Received', { actual_delivery_date: todayISO() })}
                >
                  Mark as received
                </button>
                <button onClick={() => onSetStatus(po.id, 'Cancelled')}>Cancel order</button>
              </>
            )}
            <button onClick={() => onEdit(po)}>Edit</button>
            <button className="po-card-delete" onClick={() => onDelete(po.id)}>
              Delete
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
